module.exports = __webpack_public_path__ + "static/service-cs-flexprint-half-3440dee5161d4e0e9d1bd7fae9a34b81.jpg";